import { useModal } from '../contexts';
import Modal from './Modal';
import { useTranslation } from 'react-i18next';

function OAuthModalMicrosoft() {
  const { closeModal } = useModal();
  const { t } = useTranslation();

  return (
    <Modal
      title={t("Microsoft Requires Popups")}
      size='sm'
      primaryButtonProps={{ text: t("Close"), onClick: closeModal }}
    >
      <p>
        {t("If you can't see a Microsoft File Picker window right now, you might have popups blocked.")}<br />
        {t("Please enable popups to use the Microsoft integration and try again.")}
      </p>
    </Modal>
  );
}

export default OAuthModalMicrosoft;
